export const ADMIN_PERMISSIONS = [
  { key: 'dashboard', label: 'Хянах самбар' },
  { key: 'bookings', label: 'Захиалгууд' },
  { key: 'services', label: 'Үйлчилгээнүүд' },
  { key: 'customers', label: 'Үйлчлүүлэгчид' },
  { key: 'system_users', label: 'Системийн хэрэглэгчид' },
  { key: 'website', label: 'Вэб хуудас' },
  { key: 'devops', label: 'DevOps' },
] as const

export type AdminPermissionKey = (typeof ADMIN_PERMISSIONS)[number]['key']

export const BOOKING_STATUS_CONFIG: Record<string, { label: string; color: string }> = {
  pending: { label: 'Хүлээгдэж буй', color: 'yellow' },
  confirmed: { label: 'Баталгаажсан', color: 'blue' },
  completed: { label: 'Дууссан', color: 'green' },
  cancelled: { label: 'Цуцлагдсан', color: 'red' },
}

export const SERVICE_CATEGORIES: Record<string, string> = {
  acupuncture: 'Зүү тавих',
  herbal_medicine: 'Уламжлалт эм',
  massage: 'Бариа засал',
  consultation: 'Зөвлөгөө',
  cupping: 'Банк тавих',
  moxibustion: 'Мокса эмчилгээ',
  other: 'Бусад',
}

export const ROOM_BOOKING_STATUS_CONFIG: Record<string, { label: string; color: string }> = {
  PENDING: { label: 'Хүлээгдэж буй', color: 'yellow' },
  PAID: { label: 'Төлөгдсөн', color: 'blue' },
  DONE: { label: 'Дууссан', color: 'green' },
  CANCELED: { label: 'Цуцлагдсан', color: 'red' },
}

export const GENDER_OPTIONS = [
  { value: 'male', label: 'Эрэгтэй' },
  { value: 'female', label: 'Эмэгтэй' },
  { value: 'other', label: 'Бусад' },
]
